var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.2959 15.796C20.1914 15.9009 20.0672 15.9841 19.9304 16.0409C19.7937 16.0976 19.6471 16.1269 19.499 16.1269C19.351 16.1269 19.2043 16.0976 19.0676 16.0409C18.9309 15.9841 18.8067 15.9009 18.7021 15.796L12 9.09379L5.2959 15.796C5.08455 16.0073 4.79791 16.1261 4.49902 16.1261C4.20014 16.1261 3.91349 16.0073 3.70215 15.796C3.4908 15.5846 3.37207 15.298 3.37207 14.9991C3.37207 14.7002 3.4908 14.4136 3.70215 14.2022L11.2021 6.70222C11.3067 6.59734 11.4309 6.51413 11.5676 6.45735C11.7043 6.40057 11.851 6.37134 11.999 6.37134C12.1471 6.37134 12.2937 6.40057 12.4304 6.45735C12.5672 6.51413 12.6914 6.59734 12.7959 6.70222L20.2959 14.2022C20.4008 14.3067 20.484 14.4309 20.5408 14.5677C20.5976 14.7044 20.6268 14.851 20.6268 14.9991C20.6268 15.1472 20.5976 15.2938 20.5408 15.4305C20.484 15.5673 20.4008 15.6915 20.2959 15.796Z",
    fill: "#004A99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccChevron);
export default __webpack_public_path__ + "static/media/acc-chevron.480dc7efa19857f4c9be45a369aef4b2.svg";
export { ForwardRef as ReactComponent };